import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { isBannerRecommendation, isProductRecommendation } from './guards.js';

function isValidRecommendation(recommendation) {
    return isBannerRecommendation(recommendation) || isProductRecommendation(recommendation) && CommerceToolsApi.isProductTypeName(recommendation.productType);
}

export { isValidRecommendation };
//# sourceMappingURL=is-valid-recommendation.js.map
